import Footer from '@components/ui/footer/footer';
export default Footer;
